const pvNormalizarDominio = pRespostaDominio => {
  return (Array.isArray(pRespostaDominio) ? pRespostaDominio : []).map((pItem, pIndex) => ({
    id: pItem?.id || pIndex + 1,
    discriminacao: pItem?.objetivo || pItem?.label || pItem?.pergunta || '',
    pontos: pItem?.nota ?? null
  }));
};

const pvResolverIndicePorValor = pValor => {
  const xValorNumerico = Number(pValor);

  if (!Number.isInteger(xValorNumerico) || xValorNumerico <= 0) {
    return null;
  }

  return xValorNumerico - 1;
};

const pvResolverIndicePorFaixa = (pRespostaDominio, pValor) => {
  const xValorNumerico = Number(pValor);

  if (!Number.isFinite(xValorNumerico)) {
    return null;
  }

  const xIndice = (Array.isArray(pRespostaDominio) ? pRespostaDominio : []).findIndex(pItem => {
    const xMinimoValido = pItem?.minimo == null || xValorNumerico >= Number(pItem.minimo);
    const xMaximoValido = pItem?.maximo == null || xValorNumerico <= Number(pItem.maximo);

    return xMinimoValido && xMaximoValido;
  });

  return xIndice >= 0 ? xIndice : null;
};

const pvResolverIndiceRespostaGestor = ({ resposta_tipo: pRespostaTipo, resposta_dominio: pRespostaDominio, resposta_valor: pRespostaValor }) => {
  if (pRespostaTipo === 'NUM') {
    return pvResolverIndicePorFaixa(pRespostaDominio, pRespostaValor);
  }

  if (pRespostaTipo === 'MUL' || pRespostaTipo === 'DIC') {
    return pvResolverIndicePorValor(pRespostaValor);
  }

  return null;
};

const hydrateAvaliacaoDiscriminacoes = ({
  resposta_tipo: pRespostaTipo = null,
  resposta_dominio: pRespostaDominio = [],
  resposta_valor: pRespostaValor = null
} = {}) => {
  const xIndiceRespostaGestor = pvResolverIndiceRespostaGestor({
    resposta_tipo: pRespostaTipo,
    resposta_dominio: pRespostaDominio,
    resposta_valor: pRespostaValor
  });

  return pvNormalizarDominio(pRespostaDominio).map((pItem, pIndex) => ({
    ...pItem,
    resposta_gestor: xIndiceRespostaGestor === pIndex
  }));
};

export default hydrateAvaliacaoDiscriminacoes;
